/*** IMPORTS FROM imports-loader ***/
var define = false;

'use strict';

var React = require('react');
var generator = require('./generator');


module.exports = generator("formatNumber", ["value", "options"]);



//////////////////
// WEBPACK FOOTER
// ./~/react-globalize/dist/number.js
// module id = 309
// module chunks = 0